<div class="whole-width-wrapper">
  <nav class="content-side-nav">
    <ul>
      @if (shouldRenderMobileNav) {
        <div class="nav-wrapper" #wrapper>
          <ul class="nav-content">
            @for (item of navItems; track $index) {
              <button #navButton [ngClass]="{ 'nav-item': true, active: item === currentlySelected, 'active-item': item === activeItem }" (click)="handleClick(item, $index)">
                @if (unreadIcon && unreadIcon.includes(item)) {
                  <div class="unread-icon"></div>
                }
                @if (item === 'all') {
                  {{ 'components.contentBrowser.' + item + type | translate }}
                } @else {
                  {{ shouldTranslate ? ('components.contentBrowser.' + item | translate) : item }}
                }
                @if (navItemsCounts && hasCount(item)) {
                  ({{ navItemsCounts[item] || 0 }})
                }
              </button>
            }
            <div class="placeholder-div"></div>
          </ul>
        </div>
      } @else {
        @for (item of navItems; track item) {
          <li
            [ngClass]="{ 'nav-item': true, active: item === currentlySelected, disabled: isDisabled(item) }"
            (click)="handleClick(item, -1)"
            (keydown.enter)="handleClick(item, -1)"
            [attr.tabindex]="isDisabled(item) ? -1 : 0">
            @if (unreadIcon && unreadIcon.includes(item)) {
              <div class="unread-icon"></div>
            }
            @if (item === 'all') {
              {{ 'components.contentBrowser.' + item + type | translate }}
            } @else {
              {{ shouldTranslate ? ('components.contentBrowser.' + item | translate) : item }}
            }
            @if (navItemsCounts && hasCount(item)) {
              ({{ navItemsCounts[item] || 0 }})
            }
          </li>
        }
      }
    </ul>
  </nav>
</div>
